import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import { TextareaAutosize } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    yes: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1A9FE0',
        textTransform: 'capitalize'
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    cancelText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit',
    }
}));

const RejectUserDialog = (props: any) => {
    const { open, handleopenClose, rejectUser, maxWidth } = props;
    const classes = useStyles();
    const [deactivationMessage, setdeactivationMessage] = React.useState<any>(null);
    const [deactivateTextErrorMessage, setdeactivateTextErrorMessage] = React.useState<boolean>(false);
    const [deactivationMessageError, setdeactivationMessageError] = React.useState<boolean>(false);

    const handleYesClick = () => {
        if (!deactivationMessage) {
            setdeactivationMessageError(true);
        } else if (!deactivateTextErrorMessage) {
            setdeactivationMessageError(false);
            rejectUser(deactivationMessage);
        }
        // handleopenClose(true);
    };

    const handleCancelClick = () => {
        setdeactivationMessage(null);
        setdeactivateTextErrorMessage(false);
        setdeactivationMessageError(false);
        handleopenClose(false);
    };

    const handleCustomerChange = (e: any) => {
        setdeactivationMessage(e.target.value);
        setdeactivationMessageError(false);
        if (e.target.value?.length > 100) {
            setdeactivateTextErrorMessage(true);
        } else {
            setdeactivateTextErrorMessage(false);
        }
        if (e.target.required) {
            if (e.target.value === "" || e.target.value.trim() === "") {
                setdeactivationMessageError(true);
            }
            else {
                setdeactivationMessageError(false);
            }
        }
    }


    return (
        <Dialog
            open={open}
            onClose={() => handleopenClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={maxWidth || false}
        >
            <DialogContent>
                <div className={classes.icon}>
                    <WarningIcon className="delete-warning" fontSize="small" />
                </div>
                <DialogContentText id="alert-dialog-description" component="div">
                    <div className={`mt-3 ${classes.cancelText}`}>
                        Do you wish to notify the Customer that the sub user is not approved?
                    </div>
                    <div className="row col-md-12 mb-1 mt-0 px-5">
                        <div className="col-sm-12 col-md-12 px-4 pr-2 mb-0 mt-0">
                            <div className="col-6">
                                <TextareaAutosize value={deactivationMessage}
                                    // maxLength={250}
                                    aria-label="minimum height" minRows={2} placeholder="Reason for rejection" className="textArea-correction p-4"
                                    onChange={(e: any) => handleCustomerChange(e)}
                                />
                            </div>
                        </div>
                        {deactivationMessageError &&
                            <span className="col-12 px-5" style={{ color: 'red' }}>Please enter reason for Rejection.</span>
                        }
                        {deactivateTextErrorMessage &&
                            <span className="col-12 px-5" style={{ color: 'red' }}>Only 100 characters are allowed.</span>
                        }
                        <div className='w-100'>
                            <span className='d-flex justify-content-end ' style={{ color: '#808080', fontSize: '14px' }}>
                                Maximum 100 characters
                            </span>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className={`mx-4 ${classes.yes}`} onClick={handleYesClick} autoFocus>
                    Yes
                </Button>
                <Button className={`mr-4 ${classes.cancel}`} onClick={handleCancelClick}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RejectUserDialog;
